module.exports = __webpack_public_path__ + "static/media/r.64c2f5d8.svg";